<template>
  <div class="label-wrapper">
    <span class="first-label">
      {{firstLabel}}
      <span v-if="!twoLines">
        &ndash;
      </span>
    </span>
    <br v-if="twoLines"/>
    <span class="second-label">{{secondLabel}}</span>
  </div>
</template>

<script>
export default {
  name: "TwoLabel",
  props: {
    firstLabel: String,
    secondLabel: String,
    twoLines: Boolean
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.first-label {
  font-weight: bold;
}
.label-wrapper {
  margin-bottom: 10px;
  font-size: 18px;
}
</style>
